import { Box, Chip as MaterialChip, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

interface ChipProps {
  visible: number;
}

export const List = styled(Box)(() => ({
  display: 'flex',

  '.MuiChip-root': {
    marginRight: '10px',
  },
}));

export const Chip = styled(MaterialChip)<ChipProps>(({ visible }) => ({
  opacity: visible ? 1 : 0,
  zIndex: 1,
}));

export const ChipLabelContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '5px',

  '> svg': {
    minWidth: '24px',
    minHeight: '24px',
  },

  'svg:last-of-type': {
    fill: 'rgba(34, 40, 34, 1)',
  },
}));

export const Input = styled(Box)(() => ({
  position: 'relative',
  flexGrow: 1,

  '.MuiInputBase-root': {
    padding: '0px',
  },

  '.MuiInputBase-input': {
    height: '32px',
    padding: '0px',
    color: 'rgba(34, 40, 34, 1)', // Testo visibile
    caretColor: 'black',

    '&::placeholder': {
      color: 'rgba(159, 159, 159, 1)',
      opacity: 1,
    },

    '&:placeholder-shown': {
      textOverflow: 'ellipsis',
    },
  },

  fieldset: {
    border: 'none',
  },
}));

export const Mask = styled(Typography)(() => ({
  position: 'absolute',
  top: '50%',
  transform: 'translate(0%, -50%)',
  zIndex: -1,
  width: '100%',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  fontSize: '16px',
  color: 'rgba(159, 159, 159, 1)',
}));

export const InputText = styled('span')(() => ({
  color: 'rgba(34, 40, 34, 1)',
}));

export const Count = styled(Typography)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  lineHeight: '18.2px',
  fontSize: '14px',
  fontWeight: '600',
  background: 'rgba(221, 221, 234, 1)',
  borderRadius: '50%',
  height: '20px',
  width: '20px',
  minWidth: '20px',
}));
